import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gallonToGal',
  standalone: true,
})
export class GallonToGalPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return value.replace(/gallons?/i, 'Gal');
  }
}
